import { useState, useEffect } from 'react';
import Editor from './Editor';

const ShowHtmlEditor = ({ PageContent, setPageContent, HandleForm, ForAttribute, running = 1 }) => {
    const RYEditor = 1;
    const [isEditview, setisEditview] = useState(0); // PageContent ? 0 : 1
    function getContent(value) {
        setPageContent(value);
        HandleForm(ForAttribute, value);
    }
    useEffect(() => {
        // setisEditview(PageContent ? 1 : 0);
    }, [running]);
    return (
        <div ry={RYEditor}>
            {/* #{PageContent.length}# */}
            {/* ##{isEditview}## */}
            <div style={{ border: '1px solid #dedede' }}>
                {running && (
                    <Editor
                        getContent={getContent}
                        PageContent={PageContent}
                        isEditview={isEditview}
                        setisEditview={setisEditview}
                        setPageContent={setPageContent}
                        running={running}
                    />
                )}
            </div>
        </div>
    );
};

export default ShowHtmlEditor;
